import { createFileRoute } from '@tanstack/react-router'
import { parseCalendarSearch } from '@/pages/Calendar/calendar-search'

/**
 * `/calendar`: the Agency Calendar (FE-REQUIREMENT §4). A route of its own, NOT the inert `/compliance/calendar` redirect
 * (that path keeps old bookmarks landing on the Compliance tab).
 *
 * Ungated on purpose (ADR-015): no compliance read key exists to gate it with, and data authorisation stays with the
 * resolver's fail-closed scope. No sidebar entry either: `sidebar:*` keys fail closed until seeded; entry is a link from the
 * Agency Dashboard.
 */
export const Route = createFileRoute('/calendar')({
  validateSearch: (search: Record<string, unknown>) => parseCalendarSearch(search),
})
